export default "__VITE_ASSET__C87r204v__"